/**
 * Created by Alex Aguilar on 5/16/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('seatModelAircraftService', seatModelAircraftService);

    seatModelAircraftService.$inject = ['$http', 'CONFIG', 'messageService'];

    function seatModelAircraftService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/seatModelAircrafts';

        return {
            getSeatModelAircrafts: getSeatModelAircrafts,
            getSeatModelAircraftsPage: getSeatModelAircraftsPage,
            saveSeatModelAircraft: saveSeatModelAircraft,
            updateSeatModelAircraft: updateSeatModelAircraft,
            getSeatModelAircraft: getSeatModelAircraft,
            deleteSeatModelAircraft: deleteSeatModelAircraft,
            getSeatModelAircraftByCategoryAndModelAircraft: getSeatModelAircraftByCategoryAndModelAircraft,
            getSeatModelAircraftByCategory: getSeatModelAircraftByCategory,
            getSeatModelAircraftByOne: getSeatModelAircraftByOne,
            getSeatsByNotDefault: getSeatsByNotDefault,
            getSeatsModelAircraftByCategory: getSeatsModelAircraftByCategory,
            isNotDefaultSeatModelAircraft: isNotDefaultSeatModelAircraft

        };

        function getSeatModelAircrafts(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSeatModelAircraftsPage(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveSeatModelAircraft(seatModelAircraft){
            return $http.post(urlBase, seatModelAircraft)
                .then(function(response){
                    messageService.register('seats');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('seats')
                });
        }

        function updateSeatModelAircraft(seatModelAircraft, seatModelAircraftId){
            return $http.put(urlBase + "/" + seatModelAircraftId, seatModelAircraft)
                .then(function(response){
                    messageService.registerUpdate('seats')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('seats')
                });
        }

        function getSeatModelAircraft(seatModelAircraftId){
            return $http.get(urlBase + "/" + seatModelAircraftId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSeatModelAircraftByCategoryAndModelAircraft(category,modelAircraftId,makerId){
            return $http.get(urlBase + '/' + category + '/modelAircraft/' + modelAircraftId + '_' + makerId);
        }

        function deleteSeatModelAircraft(seatModelAircraftId){
            return $http.delete(urlBase + "/" + seatModelAircraftId)
                .then(function(response){
                    messageService.registerDelete('seats')
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('seats')
                });
        }

        function getSeatModelAircraftByCategory(seatModelAircrafts, category, type){
            var res;
            if(type == 1){
                res = {};
                for (var i = 0; i < seatModelAircrafts.length; i++){
                    if(seatModelAircrafts[i].category == category){
                        res = seatModelAircrafts[i];
                        break;
                    }
                }
            }else{
                res = [];
                angular.forEach(seatModelAircrafts, function (seatModelAircraft) {
                    if(seatModelAircraft.category === category){
                        res.push(seatModelAircraft);
                    }
                })
            }
            return res;
        }

        function getSeatModelAircraftByOne(seatModelAircrafts, byDefault, category) {
            var res = null;
            for (var i = 0; i < seatModelAircrafts.length; i++){
                var seatModelAircraft = seatModelAircrafts[i];
                if(seatModelAircraft.byDefault === byDefault && seatModelAircraft.category === category){
                    res = seatModelAircraft;
                    break;
                }
            }
            return res;
        }

        function thereSeatNotDefault(seatModelAircrafts, category) {
            var res = false;

            for (var i = 0; i < seatModelAircrafts.length; i++){
                var seat = seatModelAircrafts[i];
                if(seat.category === category && !seat.byDefault){
                    res = true;
                }
            }
            return res;
        }

        function getSeatByNotDefault(seatModelAircrafts, category) {
            var res = null;

            for (var i = 0; i < seatModelAircrafts.length; i++){
                var seat = seatModelAircrafts[i];
                if(seat.category === category && !seat.byDefault){
                    res = seat;
                }
            }
            return res;
        }

        function getSeatsByNotDefault(seatModelAircrafts, firstClass, businessClass, economicClass) {
            return {
                isSeatFirst: thereSeatNotDefault(seatModelAircrafts, firstClass),
                isSeatBusiness: thereSeatNotDefault(seatModelAircrafts, businessClass),
                isSeatEconomic: thereSeatNotDefault(seatModelAircrafts, economicClass),
                seatFirst: getSeatByNotDefault(seatModelAircrafts, firstClass),
                seatBusiness: getSeatByNotDefault(seatModelAircrafts, businessClass),
                seatEconomic: getSeatByNotDefault(seatModelAircrafts, economicClass)
            }
        }

        function getSeatsModelAircraftByCategory(seatModelAircrafts, byDefault, category) {
            var res = [];
            for (var i = 0; i < seatModelAircrafts.length; i++){
                var seat = seatModelAircrafts[i];
                if(seat.category === category && seat.byDefault === byDefault){
                    res.push(seat);
                }
            }
            return res;
        }

        function isNotDefaultSeatModelAircraft(seatModelAircrafts, seatModelAircraftId, category) {
            var res = false;
            for (var i = 0; i < seatModelAircrafts.length; i++){
                var seatModelAircraft = seatModelAircrafts[i];
                if(seatModelAircraft.seatModelAircraftId === seatModelAircraftId && seatModelAircraft.category === category && !seatModelAircraft.byDefault){
                    res = true;
                    break;
                }
            }
            return res;
        }
    }
})();
